var _polygon, _path, _path2, _polygon2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.02,
    y: 56.61,
    width: 69.07,
    height: 72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.34,
    y: 56.61,
    width: 69.07,
    height: 72,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.43,128.63H387.32v-72h69.11Zm-69.07,0h69v-72h-69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.63,
    y: 66.28,
    width: 50.5,
    height: 52.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,119.28a8,8,0,0,1-1.25,1.45c-.81.85-1.94,2-3.21,3.25s-2.44,2.37-3.3,3.16a7.32,7.32,0,0,1-1.46,1.21,8.83,8.83,0,0,1,1.24-1.44c.81-.85,1.94-2,3.22-3.26s2.44-2.37,3.3-3.16A8.06,8.06,0,0,1,396.63,119.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.13,119.15a8.17,8.17,0,0,1,1.45,1.24c.85.81,2,1.94,3.25,3.21s2.37,2.44,3.16,3.3a9.11,9.11,0,0,1,1.22,1.46,7.21,7.21,0,0,1-1.45-1.24c-.85-.8-2-1.94-3.26-3.21s-2.37-2.45-3.16-3.31A7.84,7.84,0,0,1,447.13,119.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,66.43A8,8,0,0,1,448.24,65c.8-.85,1.94-2,3.21-3.26s2.43-2.36,3.3-3.16a7.32,7.32,0,0,1,1.46-1.21A8.83,8.83,0,0,1,455,58.79c-.81.85-2,2-3.22,3.26s-2.45,2.37-3.31,3.17A8.4,8.4,0,0,1,447,66.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.49,66.55A7.66,7.66,0,0,1,395,65.31c-.85-.81-2-1.94-3.25-3.21s-2.37-2.44-3.16-3.3a8.62,8.62,0,0,1-1.22-1.46,7.83,7.83,0,0,1,1.44,1.24c.86.81,2,1.94,3.27,3.22s2.37,2.44,3.16,3.3A7.84,7.84,0,0,1,396.49,66.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,118.93s0-.09,0-.26,0-.42,0-.73c0-.66,0-1.61,0-2.84,0-2.5,0-6.13-.06-10.73,0-9.22-.05-22.36-.09-38.09l.19.2-50.36,0h0l.22-.23c0,19.33,0,37.4,0,52.65l-.19-.19,36.46.09,10.25,0,2.71,0h.7a.93.93,0,0,1,.24,0h-.9l-2.68,0-10.19,0-36.59.1h-.19v-.19c0-15.25,0-33.32,0-52.65v-.22h.23l50.36,0h.2v.19c0,15.78-.07,29-.09,38.21,0,4.59,0,8.2-.06,10.69,0,1.21,0,2.15,0,2.8,0,.3,0,.54,0,.71A2.17,2.17,0,0,1,447,118.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.45,
    y: 84.18,
    width: 16.85,
    height: 16.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.02,
    y: 156.29,
    width: 69.07,
    height: 72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.34,
    y: 156.29,
    width: 69.07,
    height: 72,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.43,228.31H387.32v-72h69.11Zm-69.07,0h69v-72h-69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.63,
    y: 165.97,
    width: 50.5,
    height: 52.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,219a8,8,0,0,1-1.25,1.45c-.81.85-1.94,2-3.21,3.25s-2.44,2.37-3.3,3.16a8.18,8.18,0,0,1-1.46,1.22,8.61,8.61,0,0,1,1.24-1.45c.81-.85,1.94-2,3.22-3.26s2.44-2.37,3.3-3.16A8.06,8.06,0,0,1,396.63,219Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.13,218.83a8,8,0,0,1,1.45,1.25c.85.8,2,1.94,3.25,3.21s2.37,2.44,3.16,3.3a8.18,8.18,0,0,1,1.22,1.46,8.17,8.17,0,0,1-1.45-1.24c-.85-.81-2-1.95-3.26-3.22s-2.37-2.44-3.16-3.31A7.84,7.84,0,0,1,447.13,218.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,166.11a8,8,0,0,1,1.25-1.45c.8-.85,1.94-2,3.21-3.26s2.43-2.36,3.3-3.15a8.18,8.18,0,0,1,1.46-1.22,8.36,8.36,0,0,1-1.24,1.44c-.81.86-2,2-3.22,3.26s-2.45,2.38-3.31,3.17A7.84,7.84,0,0,1,447,166.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.49,166.24A8,8,0,0,1,395,165c-.85-.81-2-1.94-3.25-3.21s-2.37-2.44-3.16-3.3a8.18,8.18,0,0,1-1.22-1.46,7.83,7.83,0,0,1,1.44,1.24c.86.81,2,1.94,3.27,3.22s2.37,2.44,3.16,3.3A8.06,8.06,0,0,1,396.49,166.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,218.61s0-.09,0-.26,0-.42,0-.73c0-.66,0-1.61,0-2.84,0-2.5,0-6.12-.06-10.73,0-9.22-.05-22.36-.09-38.08l.19.19-50.36,0h0l.22-.22c0,19.32,0,37.4,0,52.64l-.19-.19,36.46.1,10.25,0,2.71,0h0l-2.68,0-10.19,0-36.59.1h-.19v-.19c0-15.24,0-33.32,0-52.64v-.23h.23l50.36,0h.2v.2c0,15.78-.07,28.95-.09,38.2,0,4.59,0,8.21-.06,10.69,0,1.22,0,2.15,0,2.8,0,.31,0,.54,0,.72A1.85,1.85,0,0,1,447,218.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.45,
    y: 183.86,
    width: 16.85,
    height: 16.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.16,
    y: 231.16,
    width: 54.48,
    height: 56.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.47,
    y: 231.16,
    width: 54.48,
    height: 56.8,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,288H42.45V231.14H97Zm-54.49,0H96.93V231.17H42.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.79,
    y: 238.79,
    width: 39.84,
    height: 41.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79,280.59a6.5,6.5,0,0,1-1,1.15c-.64.67-1.53,1.58-2.53,2.56s-1.93,1.87-2.61,2.5a5.81,5.81,0,0,1-1.15.95,6.78,6.78,0,0,1,1-1.13C44.14,285.94,45,285,46,284s1.93-1.87,2.6-2.49A6.56,6.56,0,0,1,49.79,280.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.63,280.49a7,7,0,0,1,1.14,1c.67.63,1.58,1.53,2.57,2.53s1.86,1.92,2.49,2.6a7.19,7.19,0,0,1,1,1.15,5.69,5.69,0,0,1-1.14-1c-.67-.63-1.58-1.53-2.57-2.53s-1.87-1.93-2.5-2.61A6.17,6.17,0,0,1,89.63,280.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52,238.9a7.18,7.18,0,0,1,1-1.14c.64-.67,1.53-1.58,2.53-2.57s1.93-1.86,2.61-2.49a6.71,6.71,0,0,1,1.15-1,6.15,6.15,0,0,1-1,1.14c-.64.67-1.53,1.58-2.54,2.57s-1.93,1.87-2.61,2.5A6,6,0,0,1,89.52,238.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.68,239a6.52,6.52,0,0,1-1.14-1c-.67-.63-1.58-1.53-2.57-2.53s-1.86-1.92-2.49-2.6a7.19,7.19,0,0,1-1-1.15,5.81,5.81,0,0,1,1.14,1c.67.64,1.58,1.54,2.57,2.54s1.87,1.93,2.5,2.61A5.81,5.81,0,0,1,49.68,239Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52,280.32a1.57,1.57,0,0,1,0-.2c0-.15,0-.34,0-.58,0-.52,0-1.27,0-2.24,0-2,0-4.83,0-8.47,0-7.27,0-17.63-.08-30l.16.16L49.8,239h0l.18-.18c0,15.24,0,29.5,0,41.53l-.15-.15,28.77.07,8.08,0,2.13,0H86.7l-8,0-28.86.08h-.15v-.15c0-12,0-26.29,0-41.53v-.17h.19l39.72,0h.15v.15c0,12.45-.06,22.84-.08,30.14,0,3.62,0,6.47,0,8.43,0,1,0,1.7,0,2.21,0,.24,0,.43,0,.56S89.52,280.32,89.52,280.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.06,
    y: 252.91,
    width: 13.29,
    height: 13.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,257.62c-10.71,5.55-18.92,15.1-24.82,25.61s-9.71,22-13.48,33.51l-3.3,59.08c12.46-21.2,22.46-46.12,25.16-70.56l-8.29-.73c5.56-.85,10.23-4.88,13.2-9.66s4.49-10.28,6-15.7l-10.11,1.5A37.51,37.51,0,0,0,454,257.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51,389.66s-27.05-32.37-26.73-63.27H394.7s-11.87-7.8-10.93-12.17S385,293.3,385,293.3l10,2.5s-7.49-3.74-8.43-9.67,2.19-33.4,2.19-33.4,12.17,12.8,15.92,25.9S418.26,307,415.38,347,410.51,389.66,410.51,389.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.22,392.71s29.29-19.52,35.8-44.43l-8.78-2.39s11.25-3.67,11.45-7.39,3.57-17.09,3.57-17.09l-8.58-.18s6.84-1.37,8.9-5.93S472.13,288,472.13,288s-12.59,7.63-18.47,17.35-17.13,19.86-23.55,52.61S424.22,392.71,424.22,392.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.16,281a1.55,1.55,0,0,1,.09.34l.24,1c.2.91.49,2.2.86,3.84s.81,3.71,1.29,6.1,1,5.08,1.59,8.09c1.16,6,2.38,13.18,3.64,21.16s2.43,16.79,3.52,26,1.88,18.12,2.51,26.18S411,389,411.19,395.13c.15,3.05.22,5.82.29,8.24s.13,4.52.14,6.23,0,3,0,3.93v1a1.35,1.35,0,0,1,0,.35,1.6,1.6,0,0,1,0-.35c0-.26,0-.6-.05-1,0-.94-.08-2.25-.14-3.94s-.12-3.79-.23-6.22-.19-5.18-.37-8.23c-.29-6.1-.77-13.36-1.39-21.41s-1.5-16.9-2.56-26.16-2.29-18.05-3.48-26-2.41-15.16-3.53-21.16c-.52-3-1.06-5.72-1.51-8.11s-.85-4.43-1.2-6.11-.58-2.94-.76-3.86c-.08-.42-.14-.75-.19-1A1.33,1.33,0,0,1,396.16,281Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.76,409.48S382,381.4,374.32,364.42l5.8-2.47c-4.2.69-8.51-1.12-11.77-3.86s-5.65-6.36-8-9.91l7.64-1.29A28.44,28.44,0,0,1,351.29,334c9,1.49,17.18,6.44,23.9,12.63a117.73,117.73,0,0,1,14.48,16.78,57.39,57.39,0,0,1,5.63,9.25C399.46,381.2,406.77,399.17,406.76,409.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.41,304.31a1.06,1.06,0,0,1-.11.29l-.38.82-1.51,3.11c-1.32,2.7-3.2,6.62-5.47,11.49s-4.91,10.69-7.73,17.21-5.78,13.75-8.74,21.39-5.6,15-7.92,21.7-4.28,12.81-5.87,17.94-2.84,9.29-3.67,12.18c-.42,1.41-.75,2.53-1,3.32l-.27.86a1.21,1.21,0,0,1-.11.29,1.14,1.14,0,0,1,.06-.31c.06-.22.13-.51.22-.87.21-.8.51-1.92.89-3.34.77-2.91,2-7.09,3.51-12.24s3.49-11.25,5.76-18S433,366.08,436,358.43s6-14.87,8.79-21.39,5.51-12.33,7.83-17.18,4.25-8.75,5.63-11.42l1.6-3.07c.17-.33.31-.59.42-.79S460.41,304.31,460.41,304.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.85,421.51a3.56,3.56,0,0,1-.12-.51c-.06-.4-.14-.9-.24-1.49-.19-1.3-.51-3.17-1-5.47s-1.09-5-1.9-8-1.86-6.22-3.11-9.57-2.65-6.45-4-9.24-2.68-5.23-3.86-7.25-2.17-3.64-2.89-4.73c-.32-.52-.58-.94-.8-1.28a2.29,2.29,0,0,1-.25-.47s.13.13.34.41l.88,1.22c.77,1.07,1.81,2.66,3,4.66s2.58,4.46,4,7.23,2.77,5.92,4.05,9.27,2.27,6.62,3.09,9.62,1.39,5.74,1.79,8.06.67,4.19.8,5.5l.15,1.5A1.64,1.64,0,0,1,408.85,421.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.35,
    y: 414.91,
    width: 54.16,
    height: 11.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.51 425.95 398.06 457.63 430.79 457.63 436.56 425.95 392.51 425.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.19,426c0,.15-10.25.27-22.89.27s-22.88-.12-22.88-.27,10.24-.26,22.88-.26S438.19,425.81,438.19,426Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.13,
    y: 50.81,
    width: 87.96,
    height: 142.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 50.81,
    width: 87.96,
    height: 142.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.95,
    y: 53.7,
    width: 80.47,
    height: 137.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.27,
    y: 71.52,
    width: 49.48,
    height: 101.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.27,137.06c-.12-9.47,8.57-18.72,18.13-20,4.56-.63,9.41.26,13.67-1.45,7.6-3.06,10-13,17.68-15.92L98.1,173H48.27Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.51,458.08c0,.14-99.63.26-222.5.26s-222.52-.12-222.52-.26,99.61-.26,222.52-.26S472.51,457.94,472.51,458.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.76,371.46H149.24a10.05,10.05,0,0,1-9.87-10.22v-308A10,10,0,0,1,149.24,43H350.76a10,10,0,0,1,9.87,10.21v308A10.05,10.05,0,0,1,350.76,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.86,356.52a9.39,9.39,0,1,1-9.39-9.22A9.3,9.3,0,0,1,253.86,356.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.67,60.35H227.48a3.21,3.21,0,0,1-3.15-3.26h0a3.21,3.21,0,0,1,3.15-3.26h45.19a3.21,3.21,0,0,1,3.15,3.26h0A3.21,3.21,0,0,1,272.67,60.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.15,
    y: 66.43,
    width: 207.31,
    height: 274.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.34,
    y: 66.43,
    width: 207.31,
    height: 274.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.74,
    y: 88.79,
    width: 172.52,
    height: 229.42,
    rx: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66,118.39l1-2.18a6.6,6.6,0,0,0,3.45,1c1.23,0,1.71-.34,1.71-.85,0-1.66-6-.45-6-4.34,0-1.88,1.53-3.4,4.64-3.4a7.86,7.86,0,0,1,3.81.91l-.92,2.2a6.17,6.17,0,0,0-2.9-.81c-1.24,0-1.69.42-1.69,1,0,1.6,5.94.4,5.94,4.26,0,1.83-1.53,3.39-4.64,3.39A8.26,8.26,0,0,1,219.66,118.39Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,108.81a1.57,1.57,0,0,1,1.73-1.51,1.54,1.54,0,0,1,1.74,1.47,1.75,1.75,0,0,1-3.47,0Zm.31,2.41h2.84v8.12H230Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,111.22v6.63c0,3.07-1.73,4.52-4.76,4.52a7.05,7.05,0,0,1-4-1.06l1-2a4.68,4.68,0,0,0,2.74.87c1.53,0,2.17-.69,2.17-2V118a3.05,3.05,0,0,1-2.41,1,3.92,3.92,0,1,1,0-7.83,2.94,2.94,0,0,1,2.54,1.12v-1ZM240.55,115a1.78,1.78,0,0,0-3.55,0,1.78,1.78,0,0,0,3.55,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.83,114.7v4.64H251v-4.18c0-1.17-.5-1.66-1.33-1.66s-1.61.57-1.61,1.91v3.93h-2.85v-8.12h2.71v.89a3.47,3.47,0,0,1,2.58-1C252.38,111.09,253.83,112.18,253.83,114.7Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,111.22v8.12h-2.71v-.87a3.2,3.2,0,0,1-2.41,1c-2,0-3.44-1.14-3.44-3.71v-4.54h2.84v4.07c0,1.26.5,1.76,1.35,1.76s1.53-.56,1.53-1.92v-3.91Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.42,115.28a3.93,3.93,0,0,1-4,4.19,3,3,0,0,1-2.27-.85v3.62h-2.84v-11H273V112a2.94,2.94,0,0,1,2.4-.94A3.93,3.93,0,0,1,279.42,115.28Zm-2.88,0a1.72,1.72,0,1,0-1.7,1.93A1.72,1.72,0,0,0,276.54,115.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,177.89V179h2v.78h-2v1.53h-1v-4.2h3.17v.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.42,178.08v3.23h-.89v-.39a1.32,1.32,0,0,1-1,.43,1.28,1.28,0,0,1-1.38-1.45v-1.82h.93v1.68c0,.54.24.78.66.78s.74-.27.74-.87v-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29,176.86h.93v4.45h-.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.09,176.86H193v4.45h-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.51,177.11v4.2h-.8l-2.09-2.55v2.55h-1v-4.2h.81l2.08,2.55v-2.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,179.46v1.85h-.88v-.41a1,1,0,0,1-1,.45c-.76,0-1.21-.42-1.21-1s.41-1,1.39-1h.74c0-.4-.24-.64-.74-.64a1.59,1.59,0,0,0-.93.3l-.34-.65a2.53,2.53,0,0,1,1.4-.39C202.73,178,203.3,178.49,203.3,179.46Zm-.94.83V180h-.64c-.44,0-.57.16-.57.37s.19.39.52.39A.68.68,0,0,0,202.36,180.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6,179.46v1.85h-.94V179.6c0-.52-.23-.76-.61-.76s-.71.27-.71.85v1.62h-.94V179.6c0-.52-.22-.76-.61-.76s-.71.27-.71.85v1.62h-.93v-3.23H205v.37a1.29,1.29,0,0,1,1-.42,1.18,1.18,0,0,1,1.06.53,1.46,1.46,0,0,1,1.17-.53A1.25,1.25,0,0,1,209.6,179.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,180h-2.44a.85.85,0,0,0,.92.64,1.09,1.09,0,0,0,.81-.31l.5.54a1.69,1.69,0,0,1-1.33.52,1.67,1.67,0,0,1-1.84-1.66A1.64,1.64,0,0,1,212,178a1.6,1.6,0,0,1,1.68,1.67C213.64,179.78,213.62,179.88,213.62,180Zm-2.45-.55h1.59a.77.77,0,0,0-.8-.67A.76.76,0,0,0,211.17,179.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.73,208.29v.78h-3.25v-4.2h3.17v.78h-2.2v.91h2v.76h-2v1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.89,207.22v1.85H191v-1.7c0-.52-.24-.76-.62-.76s-.71.27-.71.84v1.62h-.93v-1.7c0-.52-.23-.76-.62-.76s-.7.27-.7.84v1.62h-.94v-3.23h.89v.38a1.3,1.3,0,0,1,1-.42,1.21,1.21,0,0,1,1.06.52,1.45,1.45,0,0,1,1.16-.52A1.24,1.24,0,0,1,191.89,207.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,207.23v1.84h-.88v-.4a1.06,1.06,0,0,1-1,.45c-.76,0-1.21-.42-1.21-1s.41-1,1.39-1h.74c0-.41-.24-.64-.74-.64a1.52,1.52,0,0,0-.93.3l-.34-.65a2.45,2.45,0,0,1,1.4-.39C195,205.8,195.59,206.25,195.59,207.23Zm-.94.82v-.33H194c-.44,0-.57.16-.57.38s.19.39.52.39A.68.68,0,0,0,194.65,208.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.32,204.87a.59.59,0,1,1,.58.52A.53.53,0,0,1,196.32,204.87Zm.12,1h.93v3.23h-.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,204.62h.94v4.45h-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.58,208.17h-2l-.37.9h-1l1.87-4.2h1l1.88,4.2h-1Zm-.31-.74-.66-1.6-.67,1.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6,204.62v4.45h-.89v-.37a1.26,1.26,0,0,1-1,.42,1.66,1.66,0,0,1,0-3.32,1.21,1.21,0,0,1,1,.39v-1.57Zm-.92,2.84a.83.83,0,1,0-.82.89A.81.81,0,0,0,208.68,207.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.75,204.62v4.45h-.89v-.37a1.26,1.26,0,0,1-1,.42,1.66,1.66,0,0,1,0-3.32,1.23,1.23,0,0,1,1,.39v-1.57Zm-.92,2.84a.83.83,0,1,0-.82.89A.81.81,0,0,0,212.83,207.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,205.8v.86h-.21a.79.79,0,0,0-.86.9v1.52h-.93v-3.23h.89v.43A1.31,1.31,0,0,1,216.62,205.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.29,207.72h-2.44a.86.86,0,0,0,.92.65,1.08,1.08,0,0,0,.81-.31l.5.54a1.69,1.69,0,0,1-1.33.52,1.67,1.67,0,0,1-1.84-1.66,1.64,1.64,0,0,1,1.72-1.66,1.59,1.59,0,0,1,1.68,1.67A2.29,2.29,0,0,1,220.29,207.72Zm-2.45-.54h1.59a.77.77,0,0,0-.79-.68A.76.76,0,0,0,217.84,207.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.62,208.77l.31-.67a2.29,2.29,0,0,0,1.13.31c.43,0,.59-.11.59-.29,0-.53-2,0-2-1.28,0-.61.55-1,1.49-1a2.68,2.68,0,0,1,1.25.28l-.32.66a1.82,1.82,0,0,0-.93-.24c-.42,0-.6.14-.6.3,0,.56,1.95,0,1.95,1.29,0,.6-.56,1-1.52,1A2.75,2.75,0,0,1,220.62,208.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.81,208.77l.31-.67a2.28,2.28,0,0,0,1.12.31c.43,0,.6-.11.6-.29,0-.53-2,0-2-1.28,0-.61.55-1,1.49-1a2.64,2.64,0,0,1,1.24.28l-.31.66a1.87,1.87,0,0,0-.93-.24c-.42,0-.6.14-.6.3,0,.56,1.95,0,1.95,1.29,0,.6-.56,1-1.52,1A2.75,2.75,0,0,1,223.81,208.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.76,233.19c0,.94-.71,1.52-1.83,1.52h-.84v1.16h-1v-4.2h1.81C186.05,231.67,186.76,232.25,186.76,233.19Zm-1,0c0-.46-.3-.73-.89-.73h-.79v1.46h.79C185.47,233.92,185.77,233.65,185.77,233.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.21,234v1.84h-.88v-.4a1.06,1.06,0,0,1-1,.45c-.76,0-1.21-.42-1.21-1s.4-1,1.39-1h.74c0-.4-.24-.63-.74-.63a1.5,1.5,0,0,0-.93.3l-.34-.66a2.52,2.52,0,0,1,1.39-.39C189.64,232.59,190.21,233.05,190.21,234Zm-.94.82v-.33h-.64c-.44,0-.58.16-.58.38s.2.39.53.39A.7.7,0,0,0,189.27,234.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,235.57l.31-.67a2.28,2.28,0,0,0,1.12.31c.44,0,.6-.11.6-.29,0-.53-2,0-2-1.28,0-.61.55-1,1.49-1a2.61,2.61,0,0,1,1.24.29l-.31.66a1.84,1.84,0,0,0-.93-.24c-.42,0-.6.13-.6.3,0,.55,1.95,0,1.95,1.29,0,.6-.56,1-1.52,1A2.75,2.75,0,0,1,190.74,235.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,235.57l.31-.67a2.25,2.25,0,0,0,1.12.31c.43,0,.59-.11.59-.29,0-.53-1.94,0-1.94-1.28,0-.61.55-1,1.49-1a2.67,2.67,0,0,1,1.24.29l-.31.66a1.87,1.87,0,0,0-.93-.24c-.42,0-.6.13-.6.3,0,.55,1.95,0,1.95,1.29,0,.6-.56,1-1.53,1A2.73,2.73,0,0,1,193.93,235.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.55,232.64l-1.17,3.23h-.9l-.73-2-.75,2h-.9l-1.16-3.23h.88l.76,2.19.79-2.19h.8l.76,2.19.79-2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.66,234.26a1.77,1.77,0,1,1,1.77,1.66A1.66,1.66,0,0,1,202.66,234.26Zm2.59,0a.83.83,0,1,0-.82.89A.82.82,0,0,0,205.25,234.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.83,232.59v.87h-.21a.79.79,0,0,0-.86.9v1.52h-.93v-3.23h.89v.43A1.31,1.31,0,0,1,208.83,232.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,231.42v4.45h-.9v-.37a1.24,1.24,0,0,1-1,.42,1.67,1.67,0,0,1,0-3.33,1.25,1.25,0,0,1,1,.39v-1.56Zm-.92,2.84a.83.83,0,1,0-.82.89A.82.82,0,0,0,211.73,234.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.78,
    y: 284.85,
    width: 89.47,
    height: 18.31,
    rx: 4.78,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82,293.59a2.53,2.53,0,0,1,2.69-2.55,2.57,2.57,0,0,1,2.11.93l-.88.79a1.46,1.46,0,0,0-1.16-.57,1.4,1.4,0,0,0,0,2.8,1.46,1.46,0,0,0,1.16-.57l.88.8a2.59,2.59,0,0,1-2.11.92A2.53,2.53,0,0,1,224.82,293.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.71,292.18v1.2l-.3,0a.83.83,0,0,0-.91.94V296h-1.33v-3.79h1.27v.45A1.55,1.55,0,0,1,232.71,292.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.08,294.48h-2.76a.89.89,0,0,0,.94.61,1.22,1.22,0,0,0,.87-.33l.7.73a2.08,2.08,0,0,1-1.62.62,2,2,0,0,1-2.22-2,2,2,0,0,1,2.08-2,1.9,1.9,0,0,1,2,2C237.1,294.25,237.09,294.38,237.08,294.48Zm-2.78-.7h1.56a.79.79,0,0,0-1.56,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.17,293.93V296h-1.24v-.49a1.15,1.15,0,0,1-1.12.56c-.91,0-1.41-.52-1.41-1.17s.51-1.14,1.68-1.14h.76c0-.38-.28-.6-.8-.6a1.69,1.69,0,0,0-1,.33l-.45-.91a3.25,3.25,0,0,1,1.67-.44C240.46,292.18,241.17,292.73,241.17,293.93Zm-1.33.89v-.33h-.57c-.43,0-.58.16-.58.39s.18.38.49.38A.65.65,0,0,0,239.84,294.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.63,295.89a1.78,1.78,0,0,1-.93.22,1.34,1.34,0,0,1-1.54-1.45v-1.28h-.55v-1h.55v-1h1.33v1h.87v1h-.87v1.26a.4.4,0,0,0,.4.44.79.79,0,0,0,.41-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.89,294.48h-2.76a.87.87,0,0,0,.93.61,1.22,1.22,0,0,0,.87-.33l.7.73a2.06,2.06,0,0,1-1.61.62,2,2,0,0,1-2.23-2,2,2,0,0,1,2.09-2,1.9,1.9,0,0,1,2,2C248.91,294.25,248.89,294.38,248.89,294.48Zm-2.79-.7h1.56a.75.75,0,0,0-.78-.65A.76.76,0,0,0,246.1,293.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.9,295.09h-2.07l-.38,1H251l2.17-4.9h1.36l2.17,4.9h-1.44Zm-.4-1-.63-1.57-.63,1.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,294.14a2,2,0,0,1,2.17-2,1.79,1.79,0,0,1,1.78,1.05l-1,.52a.85.85,0,1,0-.75,1.3.83.83,0,0,0,.75-.51l1,.52a1.79,1.79,0,0,1-1.78,1.05A2,2,0,0,1,256.79,294.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,294.14a2,2,0,0,1,2.17-2,1.79,1.79,0,0,1,1.78,1.05l-1,.52a.85.85,0,1,0-.75,1.3.83.83,0,0,0,.75-.51l1,.52a1.79,1.79,0,0,1-1.78,1.05A2,2,0,0,1,261,294.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14,294.14a2.15,2.15,0,1,1,2.15,2A2,2,0,0,1,265.14,294.14Zm2.95,0a.81.81,0,1,0-1.6,0,.81.81,0,1,0,1.6,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,292.25V296h-1.27v-.4a1.61,1.61,0,0,1-2.74-1.27v-2.12h1.33v1.9c0,.59.23.82.63.82s.72-.26.72-.9v-1.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.93,293.87V296H277.6v-2c0-.55-.24-.78-.62-.78s-.76.27-.76.9V296h-1.33v-3.79h1.27v.41a1.6,1.6,0,0,1,1.2-.48A1.49,1.49,0,0,1,278.93,293.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.38,295.89a1.76,1.76,0,0,1-.93.22,1.34,1.34,0,0,1-1.54-1.45v-1.28h-.55v-1h.55v-1h1.33v1h.87v1h-.87v1.26a.4.4,0,0,0,.4.44.79.79,0,0,0,.41-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,179.46v-2.35h1v2.31c0,.8.35,1.13.94,1.13s.93-.33.93-1.13v-2.31h1v2.35a1.9,1.9,0,1,1-3.8,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.14,181l.31-.67a2.13,2.13,0,0,0,1.12.31c.43,0,.59-.11.59-.29,0-.53-2,0-2-1.28,0-.61.56-1,1.5-1a2.67,2.67,0,0,1,1.24.28l-.31.67a1.87,1.87,0,0,0-.93-.24c-.42,0-.6.13-.6.3,0,.55,1.95,0,1.95,1.29,0,.6-.56,1-1.53,1A2.73,2.73,0,0,1,258.14,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.78,180h-2.44a.85.85,0,0,0,.92.64,1.09,1.09,0,0,0,.81-.31l.5.54a1.7,1.7,0,0,1-1.34.52,1.68,1.68,0,0,1-1.84-1.66,1.65,1.65,0,0,1,1.72-1.66,1.6,1.6,0,0,1,1.68,1.67C264.79,179.78,264.78,179.88,264.78,180Zm-2.46-.55h1.59a.76.76,0,0,0-.79-.67A.77.77,0,0,0,262.32,179.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.42,178v.86h-.21a.79.79,0,0,0-.85.9v1.52h-.94v-3.22h.89v.42A1.31,1.31,0,0,1,267.42,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.28,179.46v1.84h-.94v-1.7c0-.52-.24-.76-.65-.76s-.77.28-.77.87v1.59H268v-3.22h.89v.38a1.42,1.42,0,0,1,1.07-.43A1.27,1.27,0,0,1,271.28,179.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,179.46v1.84h-.87v-.4a1.06,1.06,0,0,1-1,.45c-.75,0-1.2-.42-1.2-1s.4-1,1.38-1h.75c0-.4-.24-.64-.75-.64a1.61,1.61,0,0,0-.93.3l-.33-.65a2.47,2.47,0,0,1,1.39-.39C274.41,178,275,178.49,275,179.46Zm-.93.82V180h-.65c-.43,0-.57.16-.57.37s.2.39.53.39A.69.69,0,0,0,274.05,180.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.28,179.46v1.84h-.94v-1.7c0-.52-.23-.76-.61-.76s-.71.27-.71.85v1.61h-.94v-1.7c0-.52-.22-.76-.61-.76s-.71.27-.71.85v1.61h-.93v-3.22h.89v.37a1.3,1.3,0,0,1,1-.42,1.19,1.19,0,0,1,1.06.53A1.46,1.46,0,0,1,280,178,1.25,1.25,0,0,1,281.28,179.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3,180h-2.44a.85.85,0,0,0,.92.64,1.08,1.08,0,0,0,.81-.31l.5.54a1.69,1.69,0,0,1-1.33.52,1.68,1.68,0,0,1-1.84-1.66,1.65,1.65,0,0,1,1.72-1.66,1.6,1.6,0,0,1,1.68,1.67A2.28,2.28,0,0,1,285.3,180Zm-2.45-.55h1.59a.81.81,0,0,0-1.59,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,166.43H241.6a.13.13,0,0,0,0-.25H183.11a.13.13,0,0,0,0,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.94,166.43h58.49a.13.13,0,0,0,0-.25H258.94a.13.13,0,0,0,0,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.45,165.8a2.09,2.09,0,1,1,2.09,2A2,2,0,0,1,246.45,165.8Zm3.62,0a1.53,1.53,0,1,0-1.53,1.51A1.48,1.48,0,0,0,250.07,165.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,164.76v.52h-.13a.89.89,0,0,0-.93,1v1.48h-.54v-3h.51v.5A1.15,1.15,0,0,1,253,164.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.98,
    y: 185.95,
    width: 64.73,
    height: 12.68,
    rx: 3.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.98,
    y: 212.87,
    width: 134.85,
    height: 12.68,
    rx: 3.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.98,
    y: 239.87,
    width: 134.85,
    height: 12.68,
    rx: 3.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.29,
    y: 185.95,
    width: 63.54,
    height: 12.68,
    rx: 3.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.58,
    y: 259.82,
    width: 5.28,
    height: 5.28,
    rx: 0.99,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,264.74H194.59a2,2,0,0,1-2-1.95h0a2,2,0,0,1,2-1.95H310.8a2,2,0,0,1,1.95,1.95h0A1.94,1.94,0,0,1,310.8,264.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.71,272H195.19a2,2,0,0,1-1.95-1.95h0a1.94,1.94,0,0,1,1.95-1.94h18.52a2,2,0,0,1,1.95,1.94h0A2,2,0,0,1,213.71,272Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.58,
    y: 137.38,
    width: 134.85,
    height: 16.63,
    rx: 4.38,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.49,147l.22-.47a2.13,2.13,0,0,0,1.39.49c.72,0,1-.28,1-.65,0-1-2.54-.38-2.54-1.94,0-.64.51-1.19,1.61-1.19a2.48,2.48,0,0,1,1.35.37l-.2.48a2.12,2.12,0,0,0-1.15-.34c-.72,0-1,.3-1,.66,0,1,2.54.38,2.54,1.93,0,.64-.51,1.19-1.62,1.19A2.52,2.52,0,0,1,224.49,147Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,143.3a.38.38,0,0,1,.39-.38.37.37,0,0,1,.39.37.39.39,0,0,1-.78,0Zm.11,1h.57v3.18h-.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,144.28V147a1.44,1.44,0,0,1-1.65,1.63,2.38,2.38,0,0,1-1.52-.47l.28-.45a1.93,1.93,0,0,0,1.22.42c.75,0,1.09-.35,1.09-1.07v-.25a1.44,1.44,0,0,1-1.14.49,1.54,1.54,0,1,1,0-3.08,1.47,1.47,0,0,1,1.17.52v-.49Zm-.56,1.51a1.1,1.1,0,1,0-1.1,1A1,1,0,0,0,232.67,145.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.35,145.63v1.83h-.58V145.7c0-.63-.31-.93-.86-.93a.94.94,0,0,0-1,1v1.64h-.57v-3.18h.55v.48a1.37,1.37,0,0,1,1.15-.51A1.24,1.24,0,0,1,237.35,145.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,144.28v3.18h-.54V147a1.3,1.3,0,0,1-1.08.52,1.25,1.25,0,0,1-1.37-1.39v-1.83h.57v1.77c0,.62.32.93.86.93a.94.94,0,0,0,1-1v-1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.38,145.87a1.54,1.54,0,0,1-1.6,1.63,1.36,1.36,0,0,1-1.11-.52v1.64h-.58v-4.34h.55v.51a1.35,1.35,0,0,1,1.14-.54A1.54,1.54,0,0,1,247.38,145.87Zm-.58,0a1.07,1.07,0,1,0-1.07,1.12A1,1,0,0,0,246.8,145.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.61,144.28l-1.19,3.18h-.55l-.92-2.41-.93,2.41h-.55l-1.18-3.18h.54l.93,2.53,1-2.53h.48l.94,2.55,1-2.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.09,143.3a.38.38,0,0,1,.39-.38.38.38,0,1,1-.39.38Zm.1,1h.58v3.18h-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.65,147.28a1.08,1.08,0,0,1-.69.22.91.91,0,0,1-1-1v-1.74h-.54v-.48H257v-.69h.57v.69h.92v.48h-.92v1.72a.47.47,0,0,0,.5.53.7.7,0,0,0,.45-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.36,145.63v1.83h-.57V145.7c0-.63-.31-.93-.86-.93a.94.94,0,0,0-1,1v1.64h-.57V143h.57v1.72a1.41,1.41,0,0,1,1.13-.48A1.23,1.23,0,0,1,262.36,145.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,145.34h.58V147a2.52,2.52,0,0,1-1.59.53,2.15,2.15,0,1,1,1.62-3.65l-.37.38a1.65,1.65,0,0,0-1.22-.49,1.62,1.62,0,1,0,0,3.23,1.79,1.79,0,0,0,1-.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.39,145.87A1.65,1.65,0,1,1,271,147.5,1.58,1.58,0,0,1,269.39,145.87Zm2.72,0A1.07,1.07,0,1,0,271,147,1,1,0,0,0,272.11,145.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.2,145.87a1.65,1.65,0,1,1,1.65,1.63A1.58,1.58,0,0,1,273.2,145.87Zm2.72,0a1.07,1.07,0,1,0-1.07,1.12A1,1,0,0,0,275.92,145.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.34,144.28V147a1.44,1.44,0,0,1-1.65,1.63,2.38,2.38,0,0,1-1.52-.47l.28-.45a2,2,0,0,0,1.22.42c.75,0,1.1-.35,1.1-1.07v-.25a1.48,1.48,0,0,1-1.15.49,1.54,1.54,0,1,1,0-3.08,1.45,1.45,0,0,1,1.17.52v-.49Zm-.56,1.51a1.1,1.1,0,0,0-2.19,0,1.1,1.1,0,0,0,2.19,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.44,143H282v4.45h-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,146.06H283.4a1.07,1.07,0,0,0,1.15.93,1.16,1.16,0,0,0,.91-.38l.32.37a1.73,1.73,0,0,1-3-1.11,1.56,1.56,0,0,1,1.59-1.62,1.54,1.54,0,0,1,1.58,1.64A1,1,0,0,1,286,146.06Zm-2.57-.41h2a1,1,0,0,0-1-.91A1,1,0,0,0,283.4,145.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,145.71v.94h2.31a1.83,1.83,0,0,1-1.93,1.32,2.13,2.13,0,0,1-2.22-2.18,2.19,2.19,0,0,1,1-1.81,2.12,2.12,0,0,1,2.75.3.49.49,0,0,0,.62.12h0a.47.47,0,0,0,.13-.72,3,3,0,0,0-2.28-1,3.13,3.13,0,1,0,0,6.25,2.74,2.74,0,0,0,2.94-2.72v-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.22,
    cy: 92.61,
    r: 10.47,
    transform: "translate(-10.33 132.9) rotate(-22.35)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.13,
    y: 87.71,
    width: 2.19,
    height: 9.79,
    transform: "translate(162.49 -207.08) rotate(45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.13,
    y: 87.71,
    width: 2.19,
    height: 9.79,
    transform: "translate(31.53 261.33) rotate(-45)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.57,369.05l-6.49-.78a24.92,24.92,0,1,1,6.42-6.21h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.57,369.05s0-.17,0-.47,0-.78,0-1.36c0-1.19-.06-2.93-.1-5.17l.15.07h0a.09.09,0,0,1-.13,0,.09.09,0,0,1,0-.11,24.82,24.82,0,0,0,4.37-11.09,25.19,25.19,0,0,0-.21-7.85,24.87,24.87,0,0,0-3.21-8.32,25.39,25.39,0,0,0-6.72-7.19,24.12,24.12,0,0,0-9.76-4.21,25.27,25.27,0,0,0-11.28.48,24.25,24.25,0,0,0-10.28,5.85,25.19,25.19,0,0,0-3.89,4.69c-.5.87-1,1.73-1.44,2.63l-.59,1.37-.29.68-.22.71a25.12,25.12,0,0,0-1,11.36,24,24,0,0,0,3.84,10,25.33,25.33,0,0,0,7,7A24.76,24.76,0,0,0,76,371.7l2.06.36c.68.1,1.35.12,2,.18a22.88,22.88,0,0,0,3.81-.07,24.89,24.89,0,0,0,11.2-4h.06l4.78.63,1.26.17.44.07-.41,0-1.24-.13-4.85-.54h.06a24.77,24.77,0,0,1-11.27,4.11,23.39,23.39,0,0,1-3.86.1c-.66-.06-1.35-.07-2-.17L75.88,372a24.84,24.84,0,0,1-8.38-3.55,25.66,25.66,0,0,1-7.12-7.12,24.61,24.61,0,0,1-3.93-10.18,25.59,25.59,0,0,1,1-11.56l.22-.72.3-.7.59-1.39c.44-.92,1-1.8,1.48-2.68A25.31,25.31,0,0,1,64,329.35a24.57,24.57,0,0,1,10.47-6A25.77,25.77,0,0,1,86,322.91a24.63,24.63,0,0,1,9.91,4.31,25.71,25.71,0,0,1,6.8,7.32,25.05,25.05,0,0,1,3.22,8.45,25.53,25.53,0,0,1,.17,8,24.87,24.87,0,0,1-4.51,11.16l-.13-.13h0a.09.09,0,0,1,.13,0,.11.11,0,0,1,0,.06c0,2.26,0,4,0,5.23,0,.57,0,1,0,1.33S101.57,369.05,101.57,369.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.28 349.08 73.4 345.74 79.81 351.06 91.63 338.89 94.74 342.02 79.56 357.31 70.28 349.08",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.37,292.74a6.66,6.66,0,0,1,4.14-4.25c.8-.27,1.72-.45,2.17-1.15a5.21,5.21,0,0,0,.46-1.72,3.4,3.4,0,0,1,4.32-2.26,3.75,3.75,0,0,0,1.27.43c1.83,0,2.1-3.46,3.93-3.39a3.8,3.8,0,0,0-1,2.07,1.74,1.74,0,0,0,1.12,1.83c1.94.53,2.87-3.23,4.86-3,1.08.13,1.87,1.47,2.93,1.23a3.48,3.48,0,0,0,1.08-.63,2.79,2.79,0,0,1,3.71.85c.63,1,.73,2.61,1.89,2.93a2.61,2.61,0,0,0,2.06-.66,7.21,7.21,0,0,1,.69,3.2,4.36,4.36,0,0,1,3.89,4.63,9.18,9.18,0,0,1,3.39,1.21,3.24,3.24,0,0,1,1.53,3.07,2.79,2.79,0,0,0-.12.81,1.68,1.68,0,0,0,.39.79,15,15,0,0,1,2.09,2.71c.47,1.05.26,2.55-.81,3-.25.1-.55.15-.69.38a.8.8,0,0,0,0,.59,7.72,7.72,0,0,0,1.23,2.13,3.29,3.29,0,0,1,.71,2.3c-.14.82-1,1.52-1.79,1.16.85,1,1.71,2,2.56,3,.51.6,1,1.35.8,2.1-.33,1-1.76,1-2.63.49s-1.48-1.44-2.37-2a6.1,6.1,0,0,1-1.08-.63c-.25-.23-.45-.54-.77-.61-.65-.16-1,.83-.69,1.4a3.53,3.53,0,0,0,1.65,1.06c.61.29,1.23.8,1.18,1.46,0,.32-.21.61-.23.93-.06,1.12,1.63,1.34,2.27,2.25a2.72,2.72,0,0,1,0,2.38c-.32.94-1.31,2.06-2.1,1.45-.28-.21-.4-.58-.65-.82a2.46,2.46,0,0,0-1.11-.47,5.28,5.28,0,0,1-2.51-1.63c1.22.57,2.62,1.42,2.61,2.76a5.58,5.58,0,0,1-.44,1.62c-.34,1-.31,2.18-.64,3.24a2.58,2.58,0,0,1-2.3,2,2.47,2.47,0,0,1-2.65,4,2.22,2.22,0,0,0-.87-.24,1.75,1.75,0,0,0-.86.45,5.35,5.35,0,0,1-5.57.4l.73-.74a12.58,12.58,0,0,1-5.71,1c-1.93-.28-3.83-1.8-3.85-3.75,0-.84.27-1.85-.36-2.42a2.09,2.09,0,0,0-1.67-.28l-7.27.85a6.44,6.44,0,0,1-3.49-.24,2.23,2.23,0,0,1-1.22-2.91,6.36,6.36,0,0,0-3.29-1.27c-1.33-.12-2.67.19-4,.14a3.64,3.64,0,0,1-3.31-1.85c-.51-1.24.69-3,1.94-2.51-1.05-1.72-4.32-.26-5.47-1.92-.94-1.35.55-3,1-4.6-.44-.41-1.12-.49-1.58-.88-.95-.84-.37-2.42.41-3.41s1.8-2.1,1.51-3.33-1.9-2.07-1.78-3.36a1.42,1.42,0,0,1,1.48-1.25c-.19-2.49,4.5-2.84,4.7-5.32A.86.86,0,0,0,137,297a1,1,0,0,0-.4-.31,9.87,9.87,0,0,0-2.37-.48c-.8-.17-1.64-.68-1.72-1.48s1.23-1.42,1.57-.68a1.78,1.78,0,0,1,2.75-.58,1.93,1.93,0,0,1,2.07-1.26,5.63,5.63,0,0,1,2.41,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48,310.92c-2.17-2.62-5.59-3.89-8.94-4.47a8.68,8.68,0,0,0-4.24.06,3.67,3.67,0,0,0-2.62,3.06l1.27,2c1.47,3.49,5.53,5,8.39,7.47,1.24,1.08,2.53,2.49,4.18,2.38a3.55,3.55,0,0,0,2.24-1.19C165.1,317.79,164.65,313.55,162.48,310.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.83,326.3a7.61,7.61,0,0,0-5.2-8.26c.4-2.2-1.32-4.33-3.38-5.19s-4.38-.73-6.61-.6a10.24,10.24,0,0,0-14.06-.94c-4.18-2.18-9.45-.05-12.81,3.25a11.83,11.83,0,0,1-2.61,2.24,19.81,19.81,0,0,1-2.37.88c-4.35,1.63-6.84,6.65-6.4,11.27a8.29,8.29,0,0,1,.09,2.22,11.47,11.47,0,0,1-1.15,2.68,7.39,7.39,0,0,0,.09,6.12c.78,1.61,2.18,3,2.29,4.79.05.9-.24,1.8-.1,2.69.41,2.56,4,3.48,4.76,6,.16.51.18,1,.29,1.56a4.53,4.53,0,0,0,1.75,2.66c.67.5,1.52.83,2,1.54a7.44,7.44,0,0,1,.55,1.81c.44,1.49,6.11,5.11,7.66,5.21l34.79-18.28a7.34,7.34,0,0,0,2-8.26,2.78,2.78,0,0,1-.36-1.44,3.06,3.06,0,0,1,.62-1.13c1.58-2.39.21-5.59-1.38-8a3.57,3.57,0,0,1-.55-1.06A4.47,4.47,0,0,1,170.83,326.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.94,331.68a21,21,0,0,0-18.51-10.89,25.86,25.86,0,0,0-10,2.62,15.9,15.9,0,0,0-7.24,6.09c-1.67,1.48-5.23,11.63-1.86,18.78C127.08,356.21,132,365.75,136,371c8.16,10.5,17.79,7.11,17.79,7.11l4.29,8.88,12,10.18,10.71-17.46,2.33-3.77Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,360.16a2.64,2.64,0,0,0-4.45.17c-.58,1-.2,2.1.51,3.17h0c.82.44,1.5.93,2.36.6l.4-.17a2.88,2.88,0,0,0,1.41-1.54A2.56,2.56,0,0,0,151.39,360.16Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,356.16a1.69,1.69,0,0,0,2.25.7,1.62,1.62,0,0,0,.79-2.17,1.69,1.69,0,0,0-2.25-.7A1.62,1.62,0,0,0,132.07,356.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.42,351.24c.29.09,1-1.35,2.54-2.22s3.19-.72,3.25-1c0-.13-.34-.38-1.05-.47a4.61,4.61,0,0,0-2.73.57,4.47,4.47,0,0,0-1.9,2C128.25,350.76,128.28,351.2,128.42,351.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.62,358.66a11.69,11.69,0,0,0-2.84.95c-.43.19-.86.32-1.08.08a2.46,2.46,0,0,1-.39-1.35c-.16-1.19-.32-2.44-.5-3.75-.76-5.32-1.54-9.59-1.76-9.56s.23,4.36,1,9.68c.19,1.3.38,2.55.56,3.74a2.62,2.62,0,0,0,.67,1.7,1.14,1.14,0,0,0,1,.23,3.46,3.46,0,0,0,.74-.29A12.29,12.29,0,0,0,144.62,358.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.82,378.08A33.54,33.54,0,0,0,167,365.45s.36,10.37-11.75,15.64Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,347.9c.48.24,1.56-.69,3-1.35s2.87-.94,3-1.46c0-.25-.32-.54-1-.66a4.91,4.91,0,0,0-2.75.45,4.81,4.81,0,0,0-2.11,1.82C126.06,347.31,126.05,347.78,126.27,347.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.7,347.1a1.68,1.68,0,0,1-.69,2.25,1.61,1.61,0,0,1-2.23-.57,1.69,1.69,0,0,1,.68-2.25A1.61,1.61,0,0,1,149.7,347.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.49,339.89c-.09.29-1.66,0-3.27.84s-2.4,2.23-2.68,2.12c-.13-.05-.11-.5.21-1.13a4.58,4.58,0,0,1,2-1.94,4.42,4.42,0,0,1,2.73-.42C150.19,339.49,150.53,339.76,150.49,339.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,333.63c-.13.53-1.57.77-3.08,1.51s-2.65,1.64-3.14,1.41c-.22-.12-.21-.59.17-1.22a5.24,5.24,0,0,1,2.2-1.86,5.06,5.06,0,0,1,2.82-.49C146.81,333.09,147.18,333.38,147.12,333.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1,343.6c-.47-.86-.6-3.42.18-4,2.06-1.6,6.24-3.66,9.44,2.06,4.37,7.81-4.38,10.59-4.52,10.38S166.72,346.56,165.1,343.6Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.76,348s.19,0,.48,0a1.57,1.57,0,0,0,1-.55c.65-.76.61-2.46-.14-3.89a5,5,0,0,0-1.47-1.74,1.79,1.79,0,0,0-1.61-.47.79.79,0,0,0-.59.82c0,.28.15.41.12.44s-.24,0-.36-.39a1,1,0,0,1,0-.67,1.27,1.27,0,0,1,.65-.62,2.22,2.22,0,0,1,2.1.42,5.39,5.39,0,0,1,1.69,1.92c.83,1.6.85,3.52-.1,4.48a1.68,1.68,0,0,1-1.36.49C170.88,348.14,170.74,348,170.76,348Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.66,349.34a5.22,5.22,0,0,0,.19-5.58c1.22-.26,1.54-2.2,1.66-3.45s.61-2.12,0-3.19a1.34,1.34,0,0,1-.27-.68c0-.39.31-.69.58-1a6,6,0,0,0,1.45-5.56,12.76,12.76,0,0,0,5.87-2.07,4.85,4.85,0,0,0,7-4.27,4.35,4.35,0,0,0,3.58.48,12.8,12.8,0,0,0,3.35-1.62,5.14,5.14,0,0,0,5.77,3.47,1.25,1.25,0,0,1,1,0c.28.2.31.6.36.94a4,4,0,0,0,4.85,3.21,3,3,0,0,0,2.52,4c.38,0,.86,0,1,.37a.89.89,0,0,1,0,.43,5.94,5.94,0,0,0,.19,3.27,2.17,2.17,0,0,0,2.71,1.25,2.87,2.87,0,0,0-.05,2.26,1.26,1.26,0,0,0,1.94.41c.21-.25,3.69-3.17,3.74-3.5.56-4.23-4.06-6-6.34-9.64a27.84,27.84,0,0,0-9.22-8.74,20.68,20.68,0,0,0-4.87-2.25,27.36,27.36,0,0,0-6.06-.8,24.36,24.36,0,0,0-7.95.46c-4.78,1.33-8.34,5.29-11.28,9.29a20.91,20.91,0,0,0-2.88,4.85,19,19,0,0,0-1,6.67A23.86,23.86,0,0,0,121,348",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.61,347.45a3.45,3.45,0,0,1,0-1.08c0-.35.09-.78.1-1.3a4,4,0,0,0-.36-1.7,13.5,13.5,0,0,0-1.1-1.93,9.69,9.69,0,0,1-1.22-2.36,7.59,7.59,0,0,1,0-4.69,10.92,10.92,0,0,1,.74-1.6,5.57,5.57,0,0,0,.62-1.68,7.1,7.1,0,0,0-.06-1.89,12,12,0,0,1,2-8.09,10.3,10.3,0,0,1,1.5-1.75,9.51,9.51,0,0,1,1.94-1.36,10.9,10.9,0,0,1,1.1-.5c.38-.14.77-.25,1.15-.38a5.76,5.76,0,0,0,2.1-1.15c.63-.52,1.18-1.16,1.8-1.73a16.56,16.56,0,0,1,2-1.62,16,16,0,0,1,2.29-1.28,13.75,13.75,0,0,1,2.54-.84,8.8,8.8,0,0,1,5.38.44l.51.23-.15,0a10,10,0,0,1,7.51-2.34,9.91,9.91,0,0,1,6.73,3.3l-.1-.05a28.09,28.09,0,0,1,3.55-.05,9.53,9.53,0,0,1,3.35.77A6.21,6.21,0,0,1,165,315a4.2,4.2,0,0,1,.7,3.06l-.08-.13a7.43,7.43,0,0,1,4,3.05,7.59,7.59,0,0,1,1.32,4.35,7.45,7.45,0,0,1-.09,1.06,9,9,0,0,0-.16,1,1.9,1.9,0,0,0,.14.92,4.93,4.93,0,0,0,.47.8,14.76,14.76,0,0,1,1.55,3,7.24,7.24,0,0,1,.47,2.69,4.44,4.44,0,0,1-.52,1.95c-.26.49-.56.79-.68,1a1.7,1.7,0,0,0-.16.4,1,1,0,0,1,.13-.41c.11-.27.4-.58.65-1.06a4.4,4.4,0,0,0,.48-1.92,7,7,0,0,0-.49-2.64,14.59,14.59,0,0,0-1.56-3,6.58,6.58,0,0,1-.49-.82,2.13,2.13,0,0,1-.16-1c0-.35.1-.68.15-1a7.06,7.06,0,0,0,.09-1,7.46,7.46,0,0,0-1.31-4.23,7.23,7.23,0,0,0-3.91-2.94l-.1,0,0-.1a4,4,0,0,0-.68-2.9,6,6,0,0,0-2.41-2.06,9.35,9.35,0,0,0-3.27-.74,26,26,0,0,0-3.52.06h-.06l0-.05a10.13,10.13,0,0,0-13.87-.92l-.07.06-.09,0-.48-.22a8.58,8.58,0,0,0-5.22-.43,14.24,14.24,0,0,0-2.49.82,17.05,17.05,0,0,0-2.25,1.26,16,16,0,0,0-2,1.59c-.61.56-1.17,1.2-1.81,1.74a6.59,6.59,0,0,1-1,.71,7.17,7.17,0,0,1-1.15.48c-.39.13-.77.24-1.14.38a9.56,9.56,0,0,0-1.08.48,8.94,8.94,0,0,0-1.88,1.32,10.31,10.31,0,0,0-1.48,1.7,11.73,11.73,0,0,0-1.73,3.93,11.42,11.42,0,0,0-.25,4,7.42,7.42,0,0,1,0,1.94,5.85,5.85,0,0,1-.65,1.74,10.11,10.11,0,0,0-.74,1.57,7.06,7.06,0,0,0-.35,1.6,7.3,7.3,0,0,0,.29,3,9.51,9.51,0,0,0,1.19,2.34,13.4,13.4,0,0,1,1.08,1.95,4.27,4.27,0,0,1,.35,1.76c0,.52-.09.95-.12,1.3a4.67,4.67,0,0,0,0,.79C118.6,347.35,118.62,347.44,118.61,347.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.94,311.6a6.35,6.35,0,0,1-.75,0,5.81,5.81,0,0,0-2,.44,5.5,5.5,0,0,0-2.38,1.79,5.84,5.84,0,0,0-1.18,3.41,4.91,4.91,0,0,0,.09,1.1,1.13,1.13,0,0,0,.51.8l.34.16-.36.09a3.71,3.71,0,0,0-2.28,1.61,3.58,3.58,0,0,0-.53,2.19,3.91,3.91,0,0,0,.4,1.46c.16.32.28.48.26.49l-.1-.1a2.24,2.24,0,0,1-.24-.35,3.54,3.54,0,0,1-.49-1.49,3.71,3.71,0,0,1,.51-2.32,3.93,3.93,0,0,1,2.41-1.75l0,.25a1.38,1.38,0,0,1-.66-1,5,5,0,0,1-.1-1.16,6,6,0,0,1,1.26-3.57,5.66,5.66,0,0,1,2.5-1.81,5.41,5.41,0,0,1,2.05-.37,3.51,3.51,0,0,1,.57.05C136.88,311.58,136.94,311.59,136.94,311.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,313.64a1.45,1.45,0,0,1-.12.43,6.93,6.93,0,0,1-.55,1.11,4.44,4.44,0,0,1-1.31,1.33,3.22,3.22,0,0,1-2.28.47l.16-.12c0,.15,0,.3-.05.45s-.07.3-.1.46a5.31,5.31,0,0,1-1.3,2.29,5.45,5.45,0,0,1-1.74,1.26,4.88,4.88,0,0,1-1.39.4,1.45,1.45,0,0,1-.53,0,7.08,7.08,0,0,0,1.84-.57,5.51,5.51,0,0,0,1.64-1.26,5.38,5.38,0,0,0,1.22-2.19c0-.15.07-.29.09-.43s0-.29,0-.43l0-.15.14,0a3,3,0,0,0,2.1-.42,4.35,4.35,0,0,0,1.29-1.22C154.39,314.23,154.58,313.62,154.63,313.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,318.66s0,0,.06.15a1.64,1.64,0,0,1,0,.48,2.38,2.38,0,0,1-.8,1.53,4.58,4.58,0,0,1-2.38,1c-.48.07-1,.16-1.51.19a2.46,2.46,0,0,1-1.63-.4l-.11-.1.21,0a10.37,10.37,0,0,1-1.56,2.67,4.63,4.63,0,0,1-2.08,1.44,3.35,3.35,0,0,1-1.7.12,2.58,2.58,0,0,1-.45-.13c-.09,0-.14-.07-.14-.08s.22.06.6.11a3.46,3.46,0,0,0,1.62-.2,4.52,4.52,0,0,0,2-1.42,10.16,10.16,0,0,0,1.5-2.62l.08-.17.14.13.1.08a2.21,2.21,0,0,0,1.45.34,13.65,13.65,0,0,0,1.48-.17,4.5,4.5,0,0,0,2.29-.88,2.45,2.45,0,0,0,.83-1.4A4.17,4.17,0,0,0,162.77,318.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.82,286s-.13.08-.33.27a2,2,0,0,0-.57,1,2.77,2.77,0,0,0,.23,1.83,8.29,8.29,0,0,0,1.47,2l.1.11-.14.07a5.09,5.09,0,0,0-2.26,2.32,3.92,3.92,0,0,0,0,3.56,3.65,3.65,0,0,0,2.57,2l.38.07-.34.18a4.63,4.63,0,0,0-2.26,2.94,4.42,4.42,0,0,0,.32,3,4.9,4.9,0,0,0,1.21,1.59c.36.3.59.43.58.45l-.17-.08a4.22,4.22,0,0,1-.46-.3,4.63,4.63,0,0,1-1.69-4.68,4.78,4.78,0,0,1,2.35-3.11l0,.24a3.89,3.89,0,0,1-2.77-2.12,4,4,0,0,1-.46-1.95,4.51,4.51,0,0,1,.45-1.86,5.31,5.31,0,0,1,2.39-2.41l0,.18a8,8,0,0,1-1.47-2.06,2.9,2.9,0,0,1-.19-1.93,2.05,2.05,0,0,1,.65-1.06,1.26,1.26,0,0,1,.28-.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,295.34s0,.06-.08.15a3.8,3.8,0,0,1-.3.39,6.32,6.32,0,0,1-1.38,1.23,7.09,7.09,0,0,1-2.63,1.05,6.66,6.66,0,0,1-3.6-.28l.17-.11a5.72,5.72,0,0,1-2.21,4.36,4.32,4.32,0,0,1-5,.06l.2-.12a3.57,3.57,0,0,1-.22,1.85,4.71,4.71,0,0,1-.88,1.44,6.68,6.68,0,0,1-2.26,1.56,11.6,11.6,0,0,1-1.68.59,2.35,2.35,0,0,1-.62.15,4.87,4.87,0,0,1,.6-.22c.38-.14.95-.34,1.64-.66a6.77,6.77,0,0,0,2.16-1.56,3.89,3.89,0,0,0,1-3.11l-.05-.31.25.19a4.07,4.07,0,0,0,4.74-.08,5.48,5.48,0,0,0,2.12-4.15v-.18l.16.07a6.59,6.59,0,0,0,3.47.3,7.08,7.08,0,0,0,2.59-1A8.17,8.17,0,0,0,179.16,295.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.22,311.35s0,.06,0,.19a1,1,0,0,1-.34.44,4,4,0,0,1-1.89.66,4.87,4.87,0,0,1-2.92-.57,5,5,0,0,1-2.29-2.81v0l.24,0a5.73,5.73,0,0,1-2.91,2.16,6.47,6.47,0,0,1-3,.28,7,7,0,0,1-1.92-.53,2.22,2.22,0,0,1-.64-.35,10.31,10.31,0,0,0,2.59.69,6.5,6.5,0,0,0,2.84-.33,5.59,5.59,0,0,0,2.77-2.07l.15-.22.09.26v0a4.72,4.72,0,0,0,4.93,3.27,4.32,4.32,0,0,0,1.85-.55A1,1,0,0,0,177.22,311.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,295.69a7.42,7.42,0,0,0,1,2.61,6.38,6.38,0,0,0,2.14,2.08,6.23,6.23,0,0,0,3.53.78,5.89,5.89,0,0,0,2.05-.52l.15-.07,0,.16a7.74,7.74,0,0,0,1.1,2.7,8.24,8.24,0,0,0,1.54,1.75,6.26,6.26,0,0,0,.7.52.66.66,0,0,0,.59.09.44.44,0,0,0,.27-.27c0-.08,0-.13,0-.13s0,0,0,.14a.48.48,0,0,1-.27.35.78.78,0,0,1-.69-.06,5.55,5.55,0,0,1-.75-.51,7.79,7.79,0,0,1-1.62-1.76,7.7,7.7,0,0,1-1.17-2.76l.18.09a6.19,6.19,0,0,1-2.14.55,6.13,6.13,0,0,1-5.85-3,6.25,6.25,0,0,1-.74-1.94c0-.25-.06-.43-.07-.56A.63.63,0,0,1,138.81,295.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,358c-.26.07.25,1.71-.79,3.32s-2.86,2-2.8,2.21.49.2,1.23,0a4.3,4.3,0,0,0,2.37-1.75,3.76,3.76,0,0,0,.56-2.75C150.6,358.27,150.29,357.92,150.18,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.91,386.28S165,433,173.48,441.13c9.12,8.75,25.51,13.06,25.51,13.06s21.81,8.63,29.39,6.75l13.7-47a3.83,3.83,0,0,0-3.72-2.82c-1.36-.05-5.27,1.78-7.05,1.35-7.1-1.71-23.74-27.17-23.74-27.17s-15.81-21.8-29.29-19.83c-9.24,1.35-13.07,5.46-16.55,14.78a17.14,17.14,0,0,1-3.82,6Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.91 386.28 151.76 417.41 123.34 409.33 118.44 425.93 166.52 447.64 175.98 408.28 157.91 386.28",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2,441.19c-.13-.05,2-5.88,4.67-13s5-12.88,5.16-12.83-2,5.88-4.67,13S222.33,441.24,222.2,441.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.67,434.66a128.84,128.84,0,0,1,5.72-15.52,67.73,67.73,0,0,1-2.62,7.85A68.07,68.07,0,0,1,221.67,434.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.17,395.28a66.74,66.74,0,0,1,.42,7.29c.08,2,.16,3.82.24,5.14a10.79,10.79,0,0,1,.08,2.13,7.23,7.23,0,0,1-.44-2.1c-.18-1.31-.32-3.14-.4-5.15s-.09-3.85-.06-5.17A8.8,8.8,0,0,1,157.17,395.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "141.52 436.35 152.11 431.75 157.91 411.21 153.97 436.51 146.16 438.45 141.52 436.35"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.92,419.37a1.82,1.82,0,0,0-2.17.49,6.54,6.54,0,0,0-1.23,2.21Q223.39,430,220.24,438a5.22,5.22,0,0,0-.52,2.38c.09.82.73,1.63,1.47,1.52s1.1-.87,1.41-1.55a165.72,165.72,0,0,0,7.61-20.78"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.32,413.5s3.83-5.12,6.08-6.21c1.79-.87,12.44-2.75,13.74-2.5s24.2,5.27,24.2,5.27l-3,10-1.47-.68s-4.62,2.32-8.15,1.21a38.44,38.44,0,0,1-8-4.22l-3.15,1.18s3.46,1.09,3.72,2.52-1.71,1.59-1.71,1.59l-.14.63A2.08,2.08,0,0,1,99,423.87c-2-.4-5-1.1-5.62-1.82-.27-.3-1.66-2.86-1.66-2.86-2.15-1.51-2.11-3-2-3.92.24-1.84,2.19-3.89,2.19-3.89l-3.87-.21S81.82,417.55,79.32,413.5Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5,411.82c-4.65,0-9.07-.62-12.53.24a5.14,5.14,0,0,0-2.49,1.23,2.22,2.22,0,0,0-.49,2.58,2.49,2.49,0,0,0,2.06,1.06c.8,0,1.6-.12,2.41-.14a11.49,11.49,0,0,1,5.5,1.66,21.93,21.93,0,0,0,5.31,2.31c1.89.41,6.34.05,7.64-1.38",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.91,419.38s-.08.13-.29.33a4.17,4.17,0,0,1-1.1.62,13,13,0,0,1-4.52.77,8.67,8.67,0,0,1-3.16-.53,25.72,25.72,0,0,1-3.31-1.55,20.26,20.26,0,0,0-3.6-1.6,8,8,0,0,0-2-.37,18.07,18.07,0,0,0-2.15.13,3.82,3.82,0,0,1-2.26-.43,2,2,0,0,1-1-2.05,2.89,2.89,0,0,1,1.1-1.88,5.39,5.39,0,0,1,1.85-.87,22.3,22.3,0,0,1,6.79-.5l4.56.24a11.51,11.51,0,0,1,1.68.13,1.53,1.53,0,0,1-.44.05c-.28,0-.7,0-1.24,0-1.08,0-2.64,0-4.57-.09a23.53,23.53,0,0,0-6.65.6,5.15,5.15,0,0,0-1.67.8,2.36,2.36,0,0,0-.9,1.56,1.49,1.49,0,0,0,.75,1.53,3.3,3.3,0,0,0,2,.36,19.7,19.7,0,0,1,2.2-.13,8.9,8.9,0,0,1,2.14.4,20.73,20.73,0,0,1,3.68,1.67c2.22,1.23,4.31,2.21,6.24,2.13a14,14,0,0,0,4.45-.59A4.92,4.92,0,0,0,118.91,419.38Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63,410.74c0,.06-.44.28-1.22.42a19.52,19.52,0,0,1-3,.28,14.93,14.93,0,0,1-4.31-.27,22.76,22.76,0,0,1,4.3-.25c1.18,0,2.25-.07,3-.12A5.06,5.06,0,0,1,96.63,410.74Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.74,421.67A13.13,13.13,0,0,1,91.51,419a42.56,42.56,0,0,0,5,1.92A45.56,45.56,0,0,0,101.74,421.67Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.35,416.45a4.19,4.19,0,0,1,2.29.19,4.29,4.29,0,0,1,2.12.91,6.5,6.5,0,0,1-2.24-.41A6.64,6.64,0,0,1,95.35,416.45Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.31,424.3,73.54,412a1.25,1.25,0,0,1,1.28.1l27.74,17.63a1.35,1.35,0,0,1,.26,2L88.16,451.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.46 425.2 85.42 447.56 100.84 430.36 74.11 413.76 51.46 425.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.66 418.54 93.81 438.21 85.42 447.56 51.46 425.2 64.66 418.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56,419.12l-4.46,3.62a.69.69,0,0,1-1-.1h0a.69.69,0,0,1,.1-1l4.46-3.62a.69.69,0,0,1,1,.1h0A.7.7,0,0,1,79.56,419.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.57,420.76l-4.45,3.62a.69.69,0,0,1-1-.1h0a.69.69,0,0,1,.1-1l4.46-3.62a.68.68,0,0,1,1,.1h0A.69.69,0,0,1,81.57,420.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.73,422.68l-4.46,3.62a.67.67,0,0,1-1-.1h0a.67.67,0,0,1,.1-1l4.45-3.63a.69.69,0,0,1,1,.1h0A.69.69,0,0,1,83.73,422.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,425.29l-2.53,2.06a.7.7,0,0,1-1-.1h0a.69.69,0,0,1,.1-1l2.53-2.06a.7.7,0,0,1,1,.1h0A.69.69,0,0,1,84.62,425.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,418.51l-2.94,2.06a.68.68,0,0,1-1-.17h0a.68.68,0,0,1,.17-.95L75,417.38a.7.7,0,0,1,1,.17h0A.69.69,0,0,1,75.81,418.51Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,428.37l-2.54,2.54a.68.68,0,0,1-1,0h0a.68.68,0,0,1,0-1L90,427.4a.68.68,0,0,1,1,0h0A.68.68,0,0,1,91,428.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.16,451.27h0a2.23,2.23,0,0,1-3.08.68L48,428.22a2.23,2.23,0,0,1-.68-3.08h0a2.23,2.23,0,0,1,3.08-.67l37.08,23.72A2.23,2.23,0,0,1,88.16,451.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,378.54l1.08-26.42s27.05-5.86,27.72-10.72l-51-5.86-3.37,41.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.08,353.12a2.1,2.1,0,0,1-1.26-2.5,2,2,0,0,1,2.46-1.27,2.22,2.22,0,0,1,1.33,2.65,2.1,2.1,0,0,1-2.71,1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.81,335.54l-.34,4.15,49.43,3.93a3.54,3.54,0,0,0,2.19-2.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.88,352.44c0-.25-1.23-.46-2.39-1.35s-1.75-2-2-1.92,0,1.55,1.45,2.61S374.92,352.68,374.88,352.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.42,350.64c.07-.24-1-.75-1.74-1.87s-.93-2.26-1.18-2.27-.52,1.39.47,2.77S380.39,350.87,380.42,350.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,344.45c-.22-.07-.67,1.15-.13,2.57s1.66,2.05,1.78,1.85-.54-1-1-2.16S384.21,344.49,384,344.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,358.44c-.09-.24-1.26,0-2.67-.19s-2.47-.73-2.61-.53.84,1.18,2.5,1.4S374.08,358.64,374,358.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373,378.54l1.08-26.42s27.05-5.86,27.72-10.72l-51-5.86-3.37,41.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M377.28,359.16c-.41.83-3.48,77.54-3.48,77.54l-26.41-10.42a41.43,41.43,0,0,1-3.85-20.66c.82-11.94,7.82-48.58,7.82-48.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,380.22l-12.76-23.16s20.09-19,18.15-23.53L329,354.94l18.42,36.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.31,366.2a2.08,2.08,0,0,1-2.37-1.48,2,2,0,0,1,1.44-2.36,2.21,2.21,0,0,1,2.51,1.58,2.09,2.09,0,0,1-1.78,2.29",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329,354.94l1.86,3.72,44.31-22.25a3.54,3.54,0,0,0,.55-3.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.33,356.92c-.12-.22-1.29.24-2.76.08s-2.52-.81-2.68-.61.82,1.31,2.6,1.48S358.48,357.1,358.33,356.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.13,352.51c-.06-.25-1.22-.14-2.46-.7s-2-1.45-2.18-1.33.28,1.46,1.83,2.13S362.23,352.72,362.13,352.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,345.38c-.23.05,0,1.33,1.22,2.26s2.48.9,2.48.66-1-.56-1.94-1.34S362.18,345.29,362,345.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,362.52c-.2-.16-1.07.67-2.37,1.22s-2.5.66-2.52.91,1.33.57,2.86-.11S360.85,362.64,360.65,362.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.7 375.64 365.43 371.51 343.03 383.09 344.91 386.89 367.7 375.64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M242.08,413.94l7.39-2.35s13.58-10.91,28.82-9.47a75.47,75.47,0,0,1,27.58,8.61l15.85,8.68,40.75,10.91L339,375l23.17-9.61s23.16,37.3,30.16,47.8,12.32,21.1,13.15,29.75-5.68,20.75-23.59,22.81-94.56-3.06-94.56-3.06l-59-1.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.08,413.94s-.07.28-.22.81-.37,1.34-.67,2.38c-.6,2.1-1.49,5.19-2.65,9.21-2.32,8-5.72,19.78-10,34.64l-.14-.19L270.63,462c15.9.18,33.45,1.64,52.37,2.51,9.46.46,19.26.9,29.35,1.2,5,.13,10.18.25,15.37.26,2.59,0,5.21,0,7.83-.1,1.31,0,2.63-.07,3.94-.2a34.62,34.62,0,0,0,3.94-.42A29.09,29.09,0,0,0,398,459.05,19.72,19.72,0,0,0,405.27,445a17.49,17.49,0,0,0,0-2.05c-.09-.69-.15-1.38-.28-2.06a33.42,33.42,0,0,0-.93-4.05,57.12,57.12,0,0,0-3-7.87,113,113,0,0,0-8.38-14.85c-5.45-8.25-10.62-16.53-15.73-24.65l-15-24,.32.1-23.18,9.6.14-.33,23.44,55.39.18.41-.44-.11L321.67,419.6h0l-12.22-6.71c-2-1.06-3.85-2.17-5.76-3.12s-3.83-1.8-5.73-2.56a68.52,68.52,0,0,0-21.49-5,34.67,34.67,0,0,0-9.16,1,46.68,46.68,0,0,0-7.53,2.57,51.05,51.05,0,0,0-10.23,5.93h0l-5.58,1.74-1.83.55,1.79-.6,5.58-1.81h0a51.28,51.28,0,0,1,10.23-6,47.51,47.51,0,0,1,7.55-2.62,35.56,35.56,0,0,1,9.23-1,68.72,68.72,0,0,1,21.6,5q2.86,1.14,5.76,2.55c1.93,1,3.82,2.07,5.78,3.12l12.23,6.69,0,0,40.76,10.88-.26.3-23.49-55.36-.1-.23.23-.1,23.17-9.61.2-.08.12.18,15,24c5.12,8.12,10.29,16.4,15.73,24.64a111.55,111.55,0,0,1,8.42,14.91,57.67,57.67,0,0,1,3,7.94,34.12,34.12,0,0,1,.94,4.12c.14.69.2,1.39.29,2.09s.1,1.41,0,2.12a20.17,20.17,0,0,1-7.45,14.42,29.57,29.57,0,0,1-14.82,6.27,35.57,35.57,0,0,1-4,.42c-1.32.13-2.65.16-4,.2-2.64.1-5.25.09-7.85.1-5.2,0-10.33-.14-15.38-.28-10.1-.3-19.91-.75-29.37-1.22-18.92-.9-36.46-2.38-52.36-2.58l-42.24-1.26h-.19l0-.19,10.19-34.65,2.71-9.17c.31-1,.54-1.81.71-2.35S242.08,413.94,242.08,413.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.67,429.43a3.16,3.16,0,0,1,.94.12c.61.11,1.47.3,2.54.56a41.77,41.77,0,0,1,8.12,2.79,19.29,19.29,0,0,1,6.82,5.22,12,12,0,0,1,.88,1.2,7,7,0,0,1,.59,1,3.55,3.55,0,0,1,.41.87c-.09.05-.74-1.16-2.16-2.79a20.69,20.69,0,0,0-6.76-5,52.76,52.76,0,0,0-8-2.91A30.17,30.17,0,0,1,359.67,429.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,446.86s-10.45-5.94-12.48-6.06c-2.91-.18-15.72.26-17.29.16A1.54,1.54,0,0,0,74,443.35c.59,1,2,2.62,6,2.52a18.24,18.24,0,0,1,7.23,1c1,.4.71,1.61.71,1.61s-5.75.31-7.42-.08c-2.3-.54-9.89-5.7-9.89-5.7l-3-1.93s-1.27,1.54.71,4.41a51.44,51.44,0,0,0,4.46,5.45S70,452.33,72.42,455c0,0-1.75,3.3,2.23,5.22a9.88,9.88,0,0,0,2.6,3.69c1.21,1,4.27.78,6.15.9a48.54,48.54,0,0,0,8.38-.66,69.5,69.5,0,0,0,7.37-2l9.47.54.86-16.13Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,454a10.51,10.51,0,0,1-3.64-1.43,10.68,10.68,0,0,1-3.2-2.25,23.09,23.09,0,0,1,3.45,1.8A23.87,23.87,0,0,1,78.8,454Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.55,457.58a6.44,6.44,0,0,1-3-1,6.5,6.5,0,0,1-2.48-1.87,17,17,0,0,1,2.72,1.41A17.66,17.66,0,0,1,77.55,457.58Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.77,461.46a4.83,4.83,0,0,1-2.62-.73A4.8,4.8,0,0,1,73,459.07a13.45,13.45,0,0,1,2.39,1.2A13.38,13.38,0,0,1,77.77,461.46Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,447.25c5.34-7,8.08-15.65,9.19-24.36s.85-17,.42-25.75A286.66,286.66,0,0,1,182.35,447.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M192.89,387c.09.89,0-1.94,0-1-.25,12-7.29,62.89-16.44,72.8-7,7.57-72.42,4.35-72.42,4.35l.72-17.05s1.76-.51,13.51-2S154,436.51,154,436.51L162,383.22",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,383.22s0,.32-.11,1l-.39,2.8c-.36,2.47-.89,6.08-1.57,10.7-1.38,9.27-3.36,22.6-5.79,38.86l0,.14-.13,0c-7,1.79-14.68,3.65-22.92,5.39-4.12.86-8.38,1.7-12.81,2.29s-9,1.1-13.48,2l.18-.24c-.23,5.44-.47,11.19-.71,17.05l-.25-.27c4.62.21,9.52.37,14.49.49,9.36.22,18.5.27,27.33,0,4.41-.13,8.74-.33,13-.67A80.7,80.7,0,0,0,171.1,461a22,22,0,0,0,2.85-.91,6.34,6.34,0,0,0,2.41-1.53,20.16,20.16,0,0,0,3-4.91,77.48,77.48,0,0,0,3.78-10.49c2-6.92,3.41-13.5,4.58-19.52,2.31-12.05,3.62-21.9,4.38-28.72.38-3.41.6-6.07.69-7.87,0-.45,0-.85.06-1.19v0s0,0,.05,0,0,0,0,0v.83c0,.23,0,.4-.06.53a.68.68,0,0,1,0-.19s0,.07,0,.17c0-.1,0-.28,0-.51v-.79s0,0,.07,0v0q0,.52,0,1.2c-.06,1.8-.25,4.46-.59,7.88-.7,6.83-2,16.7-4.23,28.77-1.15,6-2.54,12.62-4.53,19.57a77.86,77.86,0,0,1-3.77,10.56,21.08,21.08,0,0,1-3.07,5,7,7,0,0,1-2.58,1.65,21,21,0,0,1-2.91.93,81.23,81.23,0,0,1-12.36,1.8c-4.24.35-8.58.56-13,.69-8.84.25-18,.2-27.36,0-5-.12-9.87-.28-14.49-.49l-.26,0v-.25c.25-5.87.49-11.61.73-17.05v-.19l.18,0c2.33-.5,4.59-.78,6.86-1.11l6.7-.87c4.4-.58,8.66-1.42,12.77-2.27,8.24-1.72,15.91-3.56,22.91-5.33l-.15.17c2.5-16.25,4.55-29.57,6-38.84.72-4.61,1.29-8.21,1.68-10.68.19-1.21.34-2.15.45-2.79S162,383.22,162,383.22Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/Sign up.645ad0fdf6b6a16fc0c28ca3af1fce6f.svg";
export { ForwardRef as ReactComponent };